import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type TwoFactorMethod = string;

interface TwoFactorSelectProps {
  value: TwoFactorMethod;
  onChange: (value: TwoFactorMethod) => void;
  disabled?: boolean;
}

export const TwoFactorSelect: React.FC<TwoFactorSelectProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  return (
    <div className="space-y-1">
      <label className="block text-xs font-semibold uppercase tracking-wide text-gray-700">
        Two-Factor Authentication Method
      </label>
      <Select
        value={value}
        onValueChange={onChange}
        disabled={disabled}
      >
        <SelectTrigger className="w-full text-sm">
          <SelectValue placeholder="Select 2FA method" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="disabled">Disabled</SelectItem>
          <SelectItem value="code">Two-Factor Code</SelectItem>
          <SelectItem value="totp">TOTP (Authenticator App)</SelectItem>
          <SelectItem value="sso">SSO (Azure AD)</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
